export default __webpack_public_path__ + "static/media/location-modal.3c93c989.svg";